import React, {Component} from 'react';
import {Modal, Button, FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import ErrorMessageContainer from './ErrorMessageContainer';
import axios from 'axios';
import DecimalHelpBlock from "./DecimalHelpBlock";
import Utils from "./Utils";

export default class FrameworkContractsArticleAmountsModal extends Component {
    constructor() {
        super();

        this.state = {
            validationErrors: [],
            submitDisabled: false,
            articles: {},
        };

        this.submit = this.submit.bind(this);
        this.close = this.close.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleAmountVatChange = this.handleAmountVatChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id !== 0) {
            let url = "/contracts/ajax/framework_contracts/" + this.props.id + "/articles";

            this.setState({
                validationErrors: [],
                submitDisabled: true
            }, () => {
                axios
                    .get(url)
                    .then((response) => {
                        let articles = {};
                        let data = response.data;
                        for (let key in data) {
                            if (data.hasOwnProperty(key)) {
                                articles[data[key].id] = {
                                    id: data[key].id,
                                    title: data[key].title,
                                    amount: data[key].amount_comma,
                                    amount_vat: data[key].amount_vat_comma,
                                    amount_formatted: data[key].amount_formatted,
                                    amount_vat_formatted: data[key].amount_vat_formatted,
                                };
                            }
                        }
                        this.setState({
                            validationErrors: [],
                            submitDisabled: false,
                            articles: articles
                        });
                    });
            });
        }
        else {
            this.setState({
                validationErrors: [],
                submitDisabled: false,
                articles: []
            });
        }
    }

    submit() {
        if (!this.state.submitDisabled) {
            this.setState({
                validationErrors: [],
                submitDisabled: true
            }, () => {
                let url = "/contracts/ajax/framework_contracts/" + this.props.id + "/articles";

                axios
                    .post(url, {
                        articles: this.state.articles
                    })
                    .then((response) => {
                        this.setState({
                            submitDisabled: false
                        }, () => {
                            this.close();
                        });

                        if (response.data === "ok")
                            location.reload();
                    })
                    .catch((failure) => {
                        this.setState({
                            validationErrors: failure.response.data,
                            submitDisabled: false
                        });
                    });
            });
        }
    }

    close() {
        this.props.closeCallback();
    }

    handleAmountChange(e, article_id) {
        let value = Utils.handleDecimals(e.target.value);
        let articles = this.state.articles;
        if (typeof articles[article_id] !== "undefined") {
            let amount = parseFloat(e.target.value.replace(",", "."));
            let amount_vat = Utils.calculateAmountVATFromAmount("24", amount);
            articles[article_id].amount = value;
            articles[article_id].amount_vat = amount_vat;
        }
        this.setState({articles: articles});
    }

    handleAmountVatChange(e, article_id) {
        let value = Utils.handleDecimals(e.target.value);
        let articles = this.state.articles;
        if (typeof articles[article_id] !== "undefined") {
            let amount_vat = parseFloat(e.target.value.replace(",", "."));
            let amount = Utils.calculateAmountFromAmountVAT("24", amount_vat);
            articles[article_id].amount = amount;
            articles[article_id].amount_vat = value;
        }
        this.setState({articles: articles});
    }

    render() {
        let rows = [];
        let articles = this.state.articles;

        if (Object.keys(articles).length > 0) {
            for (let key in articles) {
                if (articles.hasOwnProperty(key)) {
                    let article = articles[key];

                    rows.push(
                        <tr key={article.id}>
                            <td>{article.title}</td>
                            <td>{article.amount_formatted}</td>
                            <td>{article.amount_vat_formatted}</td>
                            <td>
                                <input type="text"
                                       value={this.state.articles[article.id].amount}
                                       onChange={(element) => this.handleAmountChange(element, article.id)}
                                       className="form-control"/>
                            </td>
                            <td>
                                <input type="text"
                                       value={this.state.articles[article.id].amount_vat}
                                       onChange={(element) => this.handleAmountVatChange(element, article.id)}
                                       className="form-control"/>
                            </td>
                        </tr>
                    );
                }
            }
        }
        else {
            rows.push(
                <tr key="0">
                    <td colSpan="5">
                        <em>{window.__js_contracts.no_articles_entered}</em>
                    </td>
                </tr>
            );
        }

        return (
            <Modal show={this.props.showModal}
                   onHide={this.close}
                   bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>{window.__js_contracts.framework_contract_article_amount_change}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorMessageContainer errors={this.state.validationErrors}/>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive">
                                <table className="table table-hover table-striped table-bordered">
                                    <thead>
                                    <tr>
                                        <th>{window.__js_contracts.article_title}</th>
                                        <th>{window.__js_contracts.old_amount}</th>
                                        <th>{window.__js_contracts.old_amount_with_vat}</th>
                                        <th>{window.__js_contracts.new_amount}</th>
                                        <th>{window.__js_contracts.new_amount_with_vat}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {rows}
                                    </tbody>
                                </table>
                            </div>

                            <div className={Object.keys(articles).length > 0 ? "" : "hidden"}>
                                <DecimalHelpBlock/>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.submit}
                            bsStyle="primary"
                            className={Object.keys(articles).length > 0 ? "" : "hidden"}
                            disabled={this.state.submitDisabled}>{window.__js_general.save}</Button>
                    <Button onClick={this.close}>{window.__js_general.close}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}